__turbopack_context__.v({
  "viewAllButton": "AlphaCollectionPage-module-scss-module__FfTKVq__viewAllButton",
});
